export default __webpack_public_path__ + "static/xcart-logo-31d110c2c3790db60b3177616dfdd902.png";